module.exports = __webpack_public_path__ + "img/in.cf6b23cb.svg";